export default __webpack_public_path__ + "static/1773-da222fb45abff9e6330601efbec13a83.gif";